














































































/*
    * Method for pupulate dropdown control - STARTS
    1.  attach                   - Specifies which DOM element that this component should detach to.String can be any valid querySelector and Object can be any valid Node.
    2.  autocomplete            - This is useful when searching large sets of data or even dynamically requesting information from an API.
    3.  browserAutocomplete     - HTML5 autocomplete attribute set to off (or any other value that is no "on").
    4.  columns                 - For arrange the add/edit form layout. Possible Views( multiCoumn 1 to 4).
    5.  create                  - A boolean value that indicates whether this field is shown in the create record form. Default value is true.
    6.  disabled                - For create a disabled input field. Tab index 'll be -1 for this field.
    7.  edit                    - A boolean value that indicates whether this field is shown in the edit record form. Default value is true.
    8.  fieldName               - Name of the field.
    9.  formCreate              - Used to find the current operation of the popup field control.
    10. hint                    - The hint property on text fields adds the provided string beneath the text field
    11. inline                  - Hides hint, validation errors when inline editor enabled.
    12. parentName              - Used to find the component name.
    13. placeholder             - Sets the input�s placeholder text
    14. readonly                - For create a readonly input field. Tab index 'll be -1 for this field.
    15. record                  - Object of the field.
    16. render                  - Custom events
    17. required                - For set the current field as required field. An mandatory css class added for these fields.
    18. rules                   - Vuetify includes simple validation through the rules prop.
                                  The prop accepts an array of callbacks. While validating rules, the current v-model value will be passed to the callback.
                                  This callback should return either true or a String, the error message.
    19. showInputs              - This is using for internal purpose, to check whether all the inputs are binded.
    20. title                   - A string that is shown on top of the table. This is optional.
    21. tooltip                 - The v-tooltip component is useful for conveying information when a user hovers over an element.
    22. tooltipList             - The v-tooltip component is useful for conveying all field information when a user hovers over an element.
*/
import Vue from 'vue';
import { Component, Prop, Watch } from "vue-property-decorator";
// import { Watch } from "vue-typescript";
import TooltipComponents from "./../../../../../Tooltips/Tooltips.vue";

/*
    * Component's properties and events
*/
@Component({
     components: { TooltipComponents }
})

export default class ComboBox extends Vue {
    /*
        * Component's props
    */
    @Prop() readonly attach!: any;
    @Prop() readonly autocomplete!: any;
    @Prop() readonly browserAutocomplete!: any;
    @Prop() readonly columns!: any;
    @Prop() readonly create!: any;
    @Prop() readonly disabled!: any;
    @Prop() readonly dropdown!: any;
    @Prop() readonly edit!: any;
    @Prop() readonly fieldName!: any;
    @Prop() readonly formCreate!: any;
    @Prop() readonly hint!: any;
    @Prop() readonly inline!: any;
    @Prop() readonly noDataAvailable!: any;
    @Prop() readonly placeholder!: any;
    @Prop() readonly parentName!: any;
    @Prop() readonly readonly!: any;
    @Prop() readonly record!: any;
    @Prop() readonly render!: any;
    @Prop() readonly required!: any;
    @Prop() readonly rules!: any;
    @Prop() readonly showInputs!: any;
    @Prop() readonly title!: any;
    @Prop() readonly tooltip!: any;
    @Prop() readonly tooltipList!: any;

    /*
        * Component's variables
    */
    valueReset!: string | null;
    tooltipIcon: boolean = false;
    tooltipOption: boolean = false;
    translateKey!: string;

    /*
        * The mounted() method gives you access to templates and enables interaction with the DOM.
    */
    mounted() {
        this.translateKey = "";
        this.valueReset = null;
        this.tooltipIcon = false;
        this.tooltipOption = false;
    }
    
    /*
        *  A component�s data option must be a function, so that each instance can maintain an independent copy of the returned data object.
        *  valueReset     - reset dropdown values.
        *  tooltipIcon    - tootip icon show in mouseover
        *  tooltipOption  - tootip dialog show in mouseover
    */
    data() {
        return { translateKey: null, valueReset: null, tooltipIcon: false, tooltipOption: false }
    }

    /*
        *  Vue provides a more generic way to react to data changes through the watch option
    */
    @Watch('valueReset')
    onPropertyChanged(value: string, oldValue: string) {
        if (value === "") {
            this.record[this.fieldName] = null;
        }
    }      

    /*
        * It performs the dropdown selection change event.
    */
    _dpChange(e) {
        let context = this.$store.state[this.parentName];

        //#.If checking event true annotation is enable.
        // @ts-ignore
        if (this.$attrs.field.event) {
            // @ts-ignore
            let action = this.$attrs.field.value;
            action = action.charAt(0).toLowerCase() + action.slice(1);

            //#.Change are triggered with the store.dispatch method.
            // @ts-ignore
            this.$store.dispatch(context.fileName + '/' + action + 'Change', e);
        }

        //#.Trigger changes
        context.isDirty = true;
    }

    /*
        * It performs the dropdown option click event.
    */
    _dpClick(e) {
        let context = this.$store.state[this.parentName],
            fieldName = this.fieldName,
            item = context.formData;

        if (context.card.type != context.type._form) {
            return;
        }

        //#. Check if the component is enabled redirect options
        let render = context.fields.find(x => x.value == fieldName).render;

        if (render && context.editedIndex == -1 && context.dashboard.componentId != 0) {
            //#.selectionChanged event raising methods
            // @ts-ignore
            this.$store.dispatch(context.fileName + '/selectionChanged', { item, fieldName });
        }
    }

    /*
        * Method for show tooltip
    */
    _tpShowTooltip() {
        if (!this.tooltip) {
            return;
        }

        this.tooltipOption = true;
    }

    /*
        * Method for remove tooltip
    */
    _tpRemoveTooltip() {
        if (!this.tooltip) {
            return;
        }

        this.tooltipOption = false;
        this.tooltipIcon = false;
    }

    /*
        *  Key translator
    */
    get translator(): string {
        let context = this.$store.state[this.parentName];

        if (context && !context.keyTranslator) {
            this.translateKey = this.title;
            return this.translateKey;
        }
        this.translateKey = this.$t(this.title) || this.title;
        return this.translateKey;
    }
}
